<div *ngIf="!loading">
  <app-landing [folders]="folders"></app-landing>
</div>
